import { ReactElement, ReactNode } from 'react';
import { formatISO, startOfYear } from 'date-fns';
import { Box, LoadingContainer } from '@ff-it/ui';
import { ReportContainer } from '../common';
import { ReportRenderer } from './ReportRenderer';
import { ReportTable } from 'components/ReportTable';
import { TableFilter } from 'components/ControlledTable';
import { XLSXDownloadButton } from 'components/ReportTable/XLSXDownload';
import { Filter } from './Filter';

interface RevenueProps {
  global: boolean;
  url: string;
  filterFields: ReactNode;
  storageKey: string;
}

const defaultFilter = {
  year: formatISO(startOfYear(new Date()), { representation: 'date' }),
};

export function Revenue({ global, url, filterFields, storageKey }: RevenueProps): ReactElement {
  // FIXME: use ContolledTable with single page or at least storage and state management
  return (
    <ReportContainer title="Revenue">
      <ReportTable
        defaultFilter={defaultFilter}
        storageKey={storageKey}
        columns={[]}
        url={url}
        queryParams={{ page: undefined, page_size: undefined }}
        renderTable={({ isLoading, data }) => (
          <LoadingContainer loading={isLoading}>
            <Box display="flex" mt="2">
              <Box>
                <TableFilter>
                  <Filter global={global}>{filterFields}</Filter>
                </TableFilter>
              </Box>
              <XLSXDownloadButton url={url} />
            </Box>
            {data && <ReportRenderer data={data.rows as any} />}
          </LoadingContainer>
        )}
      />
    </ReportContainer>
  );
}
